import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    // margin: props.inputMargin,
    // margin: "1rem 0rem 1.3rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "#000000",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      fontFamily: '"Source Sans Pro",sans-serif',
      height: "24px",
    },
    "& .Mui-disabled": {
      color: "#000000",
      opacity: "1",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  chipstyledisabled: {
    "& .MuiChip-deleteIcon	": {
      display: "none",
    },
    fontSize: "12px",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "24px",
    cursor: "pointer",
  },
  chipstyle: {
    fontSize: "12px",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "24px",
    cursor: "pointer",
    margin: "0 5px 0 5px",
  },
  chipdiv: {
    borderRadius: "4px",
    border: "1px solid #bdbdbd",
    height: "45px",
    paddingTop: "10px",
    margin: "2px 8px",
  },
  nofilediv: {
    paddingLeft: "13px",
    color: "#000000",
    paddingTop: "1px",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
}));

export default function AutocompleteInputMeters(props) {
  const {
    inputTitle,
    selected,
    list,
    handleChange,
    specialWidth,
    isRequired,
    isMultiple,
    disabled,
    inputMargin,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.input}>
      <Autocomplete
        required={isRequired}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => option.name || ""}
        id="controllable-states-meters"
        //options={list.map((option) => option.name)}
        options={list}
        style={{ width: specialWidth, margin: inputMargin }}
        renderInput={(params) =>
          <TextField
            {...params}
            style={{ margin: "2px 8px" }}
            label={inputTitle}
            variant="outlined"
            className={classes.textField}
          />}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
}

AutocompleteInputMeters.defaultProps = {
  specialWidth: "99%",
  isRequired: false,
  inputMargin: "1rem 0rem 1.3rem",
};

AutocompleteInputMeters.propTypes = {
  isRequired: PropTypes.bool,
  specialWidth: PropTypes.string,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
  inputMargin: PropTypes.string,
};
